module.exports = __webpack_public_path__ + "img/glypha-avanced.f7ae639e.svg";